<template>
  <el-dialog title="保证金账户详情" :visible="true" width="720px" :before-close="handleClose"  :close-on-click-modal="false">
    <div class="detail">
      <el-form :inline="true" label-width="170px">
        <div class='link-top'></div>
        <el-row class="line">
          <el-col :span="12">
            <el-form-item label="市场：">
              {{ row.matchAccountDTO.marketName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保证金账号：">
              {{ row.matchAccountDTO.settleAccount }}
            </el-form-item>
            <div class='link-center'></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="总资产：">
              {{ row.userFundInfoDto.sum | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现金可用金额：">
              {{ row.userFundInfoDto.ava | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现金可提现金额：">
              {{ row.userFundInfoDto.ava | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现金冻结金额：">
              {{ row.userFundInfoDto.freeze | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抵押保证金可用余额：">
              {{ row.userFundInfoDto.pledgeAva | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抵押保证金冻结金额：">
              {{ row.userFundInfoDto.pledgeFreeze | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账户状态：">
              {{ row.matchAccountDTO.accountStatus === 'NORMAL' ? '正常' : '冻结' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'bzj-account-detail',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleClose () {
      this.$emit('done')
    }
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__title {
    font-size: 16px;
    color: rgba(51,51,51,0.94);
    font-family: '微软雅黑'
  }
  ::v-deep .el-dialog__header {
    padding-bottom: 0px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  .line {
    border-bottom: solid #ccc 1px;
  }
  .link-top {
    width: 100%;
    height: 1px;
    border-top: solid #f8bd47 1px;
    margin-bottom: 15px;
  }
  .link-center {
    width: 100%;
    height: 1px;
    margin-top: 15px;
  }
</style>
